import styles from "./style.module.scss";
const SiderMenu = ({
  tabs,
  nowTab,
  setNowTab,
}: {
  tabs: { label: string; key: string; hide: boolean }[];
  nowTab: string;
  setNowTab: (val: string) => void;
}) => {
  const MenuItem = ({ label, tabKey }: { label: string; tabKey: string }) => (
    <div
      className={`${styles.menuItem} ${nowTab === tabKey ? styles.active : ""}`}
      onClick={() => {
        // console.log("key", tabKey);
        setNowTab(tabKey);
      }}
    >
      {label}
    </div>
  );
  return (
    <div className={styles.siderMenu}>
      {tabs
        ?.filter((_menu) => !_menu.hide)
        .map((tab) => (
          <MenuItem key={tab.key} tabKey={tab.key} label={tab.label} />
        ))}
    </div>
  );
};

export default SiderMenu;
